import { render, staticRenderFns } from "./p-setup-info.vue?vue&type=template&id=6a489f6f&scoped=true"
import script from "./p-setup-info.vue?vue&type=script&lang=js"
export * from "./p-setup-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a489f6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a489f6f')) {
      api.createRecord('6a489f6f', component.options)
    } else {
      api.reload('6a489f6f', component.options)
    }
    module.hot.accept("./p-setup-info.vue?vue&type=template&id=6a489f6f&scoped=true", function () {
      api.rerender('6a489f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-add-package-popup/p-setup-info.vue"
export default component.exports